import { useWatch } from 'react-hook-form';
import { getGoalEditPermissions } from 'helpers';
import { useUserRoles } from 'hooks/users';

export default function useGoalEditPermissions(
  index: number,
  hasRestrictionForTemplateGoal: boolean,
  isActiveOwnScorecard: boolean,
) {
  const { isRevOpsManager, isReviewCycleManager } = useUserRoles();
  const [allowScorecardOwnerEdits, allowScorecardMetricPmOwnerEdits, goalType] =
    useWatch({
      name: [
        `goals.${index}.allowScorecardOwnerEdits`,
        `goals.${index}.allowScorecardMetricPmOwnerEdits`,
        `goals.${index}.type`,
      ],
    });

  return getGoalEditPermissions({
    goalType,
    allowScorecardOwnerEdits,
    allowScorecardMetricPmOwnerEdits,
    isRevOpsManager: Boolean(isRevOpsManager),
    isReviewCycleManager: Boolean(isReviewCycleManager),
    hasRestrictionForTemplateGoal,
    isActiveOwnScorecard,
  });
}
